import { djedi } from 'djedi-react'
import api from 'api'
import config from 'config.js'

if (config.SENTRY_DSN) {
    Raven.config(config.SENTRY_DSN).install()
}

djedi.options.baseUrl = `${api.client.apiUrl}/cms/api`
djedi.options.languages.default = 'sv-se'

djedi.options.defaultRender = state => {
    switch (state.type) {
        case 'loading':
            return 'Laddar…'
        case 'error':
            return `Innehållet gick inte att hämta 😞 (${state.error.status})`
        case 'success':
            return state.content
        default:
            return null
    }
}

djedi.injectAdmin()



// WEBPACK FOOTER //
// ./_shared.js